var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-3 gap-4"},[_c('div',{staticClass:"col-span-2"},[_c('MessageChatsWazzupSection')],1),_c('div',{staticClass:"col-span-1"},[_c('InfoChatWazzupSection')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }